// extracted by mini-css-extract-plugin
export var root = "b1b919bf59692fcb81b71649a81d7536-css";